import React from 'react'
import {
  DatatableNonResponsiveRow,
  DatatableNonResponsiveCell,
} from '../../atoms/DatatableNonResponsive/DatatableNonResponsive'
import { Trans } from '../../atoms'
import { priceNotation } from '../../../utils/safe'
import useTrans from '../../../hooks/useTrans'

const DatatableRowPersonalizzazioneOrdine = ({
  totale_personalizzazione,
  stesso_logo,
  personalizzazione_posizione_1,
  personalizzazione_posizione_2,
  confezionamento_richiesto_personalizzazione,
  confezionamento_richiesto,
  confezionamento,
  articolo,
}) => {
  const t = useTrans()
  const cols = {
    prodotto: { label: t('Descrizione'), mobileCols: 12 },
    modifica: { label: '', width: '165px', mobileHidden: true },
    prezzoPezzo: { label: t('Prezzo/Pz'), width: '100px', mobileCols: 6 },
    spacer: { label: '', width: '100px', mobileHidden: true }, // Per allinearla alle righe del carrello che hanno la quantità
    totale: { label: t('Totale'), width: '100px', mobileCols: 6 },
    elimina: { label: '', width: '36px', mobileHidden: true },
    actionsMobile: { label: '', desktopHidden: true, mobileCols: 12 },
  }

  const getAreaStampa = (personalizzazione) => {
    const areeStampa = personalizzazione?.aree_stampa || []
    if (!articolo?.colore?.id) return areeStampa[0]
    return areeStampa.find((area) => area.colore?.id === articolo.colore.id)
  }

  return (
    <>
      {personalizzazione_posizione_1 && (
        <DatatableNonResponsiveRow className="datatable-row-personalizzazione">
          <DatatableNonResponsiveCell col={cols.prodotto}>
            <div className="datatable-row-personalizzazione__info">
              <div
                style={{
                  width: '86px',
                  textOverflow: 'ellipsis',
                  overflowX: 'hidden',
                  fontWeight: '700',
                  whiteSpace: 'nowrap',
                }}
              >
                {t('Personalizzazione')}
              </div>
              <div
                className="datatable-row-personalizzazione__info__content"
                style={{ marginLeft: '16px' }}
              >
                <p>
                  <Trans chiave="Posizione 1" />
                </p>
                <p className="datatable-row-personalizzazione__info__title">
                  {personalizzazione_posizione_1.tecnica.nome}
                </p>
                <p>
                  {personalizzazione_posizione_1.posizione.nome}{' '}
                  {personalizzazione_posizione_2 &&
                    (stesso_logo ? t('con loghi uguali') : t('con loghi diversi'))}
                  {personalizzazione_posizione_1.descrizione_posizione && (
                    <>
                      {' ('}
                      <Trans chiave="note: " />
                      {personalizzazione_posizione_1.descrizione_posizione}
                      {')'}
                    </>
                  )}
                </p>
                <p>
                  <Trans chiave="Numero Colori" />:{' '}
                  {personalizzazione_posizione_1.numero_colori_posizione.nome}
                </p>
                <p>
                  {personalizzazione_posizione_1.pantoni?.map((pantone, i) => {
                    return (
                      t('Colore') +
                      ` ${i + 1} - ${pantone.pantone}${
                        i !== personalizzazione_posizione_1.pantoni.length - 1 ? ', ' : ''
                      }`
                    )
                  })}
                </p>
                {confezionamento_richiesto_personalizzazione !== 'D' ? (
                  <>
                    <p>{confezionamento}</p>
                    <p>
                      <Trans chiave="Confezionamento richiesto:" />{' '}
                      {confezionamento_richiesto ? <Trans chiave="SI" /> : <Trans chiave="NO" />}
                    </p>
                  </>
                ) : (
                  <p>{confezionamento}</p>
                )}
              </div>
              {!!getAreaStampa(personalizzazione_posizione_1)?.immagine_thumb_url && (
                <div
                  className="datatable-row-personalizzazione__area-stampa-image configurazione-prodotto__posizioni__image"
                  style={{ marginLeft: '16px' }}
                >
                  <img
                    src={getAreaStampa(personalizzazione_posizione_1).immagine_thumb_url}
                    alt={t('Immagine articolo con area di stampa')}
                  />
                </div>
              )}
            </div>
          </DatatableNonResponsiveCell>
        </DatatableNonResponsiveRow>
      )}
      {personalizzazione_posizione_2 && (
        <DatatableNonResponsiveRow className="datatable-row-personalizzazione">
          <DatatableNonResponsiveCell col={cols.prodotto}>
            <div className="datatable-row-personalizzazione__info">
              <div
                style={{
                  width: '86px',
                  textOverflow: 'ellipsis',
                  overflowX: 'hidden',
                  fontWeight: '700',
                  whiteSpace: 'nowrap',
                }}
              >
                {t('Personalizzazione')}
              </div>
              <div className="datatable-row-personalizzazione__info__content">
                <p>
                  <Trans chiave="Posizione 2" />
                </p>
                <p className="datatable-row-personalizzazione__info__title">
                  {personalizzazione_posizione_2.tecnica.nome}
                </p>
                <p>
                  {personalizzazione_posizione_2.posizione.nome}{' '}
                  {personalizzazione_posizione_2 &&
                    (stesso_logo ? t('con loghi uguali') : t('con loghi diversi'))}
                  {personalizzazione_posizione_2.descrizione_posizione && (
                    <>
                      {' ('}
                      <Trans chiave="note: " />
                      {personalizzazione_posizione_2.descrizione_posizione}
                      {')'}
                    </>
                  )}
                </p>
                <p>
                  <Trans chiave="Numero Colori" />:{' '}
                  {personalizzazione_posizione_2.numero_colori_posizione.nome}
                </p>
                <p>
                  {personalizzazione_posizione_2.pantoni?.map((pantone, i) => {
                    return (
                      t('Colore') +
                      ` ${i + 1} - ${pantone.pantone}${
                        i !== personalizzazione_posizione_2.pantoni.length - 1 ? ', ' : ''
                      }`
                    )
                  })}
                </p>
                {confezionamento_richiesto_personalizzazione !== 'D' ? (
                  <>
                    <p>{confezionamento}</p>
                    <p>
                      <Trans chiave="Confezionamento richiesto:" />{' '}
                      {confezionamento_richiesto ? <Trans chiave="SI" /> : <Trans chiave="NO" />}
                    </p>
                  </>
                ) : (
                  <p>{confezionamento}</p>
                )}
              </div>
              {!!getAreaStampa(personalizzazione_posizione_2)?.immagine_thumb_url && (
                <div
                  className="datatable-row-personalizzazione__area-stampa-image configurazione-prodotto__posizioni__image"
                  style={{ marginLeft: '16px' }}
                >
                  <img
                    src={getAreaStampa(personalizzazione_posizione_2).immagine_thumb_url}
                    alt={t('Immagine articolo con area di stampa')}
                  />
                </div>
              )}
            </div>
          </DatatableNonResponsiveCell>
        </DatatableNonResponsiveRow>
      )}
      <DatatableNonResponsiveRow className="datatable-row-personalizzazione">
        <DatatableNonResponsiveCell col={cols.prodotto}></DatatableNonResponsiveCell>
        <DatatableNonResponsiveCell col={cols.prezzoPezzo}></DatatableNonResponsiveCell>
        <DatatableNonResponsiveCell col={cols.spacer}> </DatatableNonResponsiveCell>
        <DatatableNonResponsiveCell col={cols.totale}>
          <b>{priceNotation(totale_personalizzazione, 3)} €</b>
        </DatatableNonResponsiveCell>
      </DatatableNonResponsiveRow>
    </>
  )
}

export default DatatableRowPersonalizzazioneOrdine
